export const equipment = {
    namespaced: true,

    state: {
        categories: [],
        selectedCategory: null,
        selectedEquipment: null
    },

    getters: {
        categories(state) {
            return state.categories;
        },

        selectedCategory(state) {
            return state.selectedCategory;
        },

        selectedEquipment(state) {
            return state.selectedEquipment;
        }
    },

    mutations: {
        setCategories(state, categories) {
            state.categories = categories;
        },

        selectCategory(state, category) {
            state.selectedCategory = category;
        },

        selectEquipment(state, equipment) {
            state.selectedEquipment = equipment;
        }
    }
};

export default equipment;
